import {
    MIXPANEL_STATISTICS_PREFIXES,
    MIXPANEL_STATISTICS_PROPS,
} from './constants';
import { AmountPerEngine, AmountPerPool, AmountPerStyle } from './types';

export const keyWithPrefixBuilder = (
    prefix: MIXPANEL_STATISTICS_PREFIXES,
    key: MIXPANEL_STATISTICS_PROPS
) => `${prefix} ${key}` as const;

export const perEngineValues = (
    { keywords, industries, monograms, generic }: AmountPerEngine,
    prefix: MIXPANEL_STATISTICS_PREFIXES,
    key: MIXPANEL_STATISTICS_PROPS
) => ({
    [`${keyWithPrefixBuilder(prefix, key)} - Keywords Engine`]: keywords,
    [`${keyWithPrefixBuilder(prefix, key)} - Industries Engine`]: industries,
    [`${keyWithPrefixBuilder(prefix, key)} - Monograms Engine`]: monograms,
    [`${keyWithPrefixBuilder(prefix, key)} - Generic Engine`]: generic,
});

export const perPoolValues = (
    { exploitation, exploration }: AmountPerPool,
    prefix: MIXPANEL_STATISTICS_PREFIXES,
    key: MIXPANEL_STATISTICS_PROPS
) => ({
    [`${keyWithPrefixBuilder(prefix, key)} - Exploitation Pool`]: exploitation,
    [`${keyWithPrefixBuilder(prefix, key)} - Exploration Pool`]: exploration,
});

export const perStyleValues = (
    {
        three_d,
        vintage,
        cartoon,
        handdrawn,
        geometric,
        minimalist,
        watercolor,
    }: AmountPerStyle,
    prefix: MIXPANEL_STATISTICS_PREFIXES,
    key: MIXPANEL_STATISTICS_PROPS
) => ({
    ...(three_d !== undefined && { [`${prefix} ${key} - 3d`]: three_d }),
    ...(vintage !== undefined && { [`${prefix} ${key} - Vintage`]: vintage }),
    ...(cartoon !== undefined && { [`${prefix} ${key} - Cartoon`]: cartoon }),
    ...(handdrawn !== undefined && {
        [`${prefix} ${key} - Hand Drawn`]: handdrawn,
    }),
    ...(geometric !== undefined && {
        [`${prefix} ${key} - Geometric`]: geometric,
    }),
    ...(minimalist !== undefined && {
        [`${prefix} ${key} - Minimalist`]: minimalist,
    }),
    ...(watercolor !== undefined && {
        [`${prefix} ${key} - Watercolor`]: watercolor,
    }),
});
